import {
    createTheme,
    DEFAULT_THEME,
    mergeMantineTheme,
    Portal,
    Popover,
    Switch,
} from '@mantine/core';

export const calensyncTheme = createTheme({
    colors: {
        primary: [
            '#e5f3ff',
            '#D8E0FB',
            '#9bc4ff',
            '#66a3fe',
            '#577CFF',
            '#1f76fc',
            '#0b6dfd',
            '#005ce2',
            '#0052cb',
            '#0046b4',
        ],
    },
    primaryColor: 'primary',
    defaultRadius: 'sm',
    components: {
        Portal: Portal.extend({
            defaultProps: {
                reuseTargetNode: false,
            },
        }),
        Popover: Popover.extend({
            defaultProps: {
                hideDetached: false,
            },
        }),
        Switch: Switch.extend({
            defaultProps: {
                withThumbIndicator: false,
            },
        }),
    },
});

export const marketingLayoutTheme = mergeMantineTheme(
    mergeMantineTheme(DEFAULT_THEME, calensyncTheme),
    createTheme({
        headings: {
            sizes: {
                h1: {
                    fontSize: 'calc(1.425rem + 2.1vw)',
                    lineHeight: '1',
                },
                h2: {
                    fontSize: 'calc(1.025rem + 0.6vw)',
                    lineHeight: '1',
                    fontWeight: '300',
                },
            },
        },
    }),
);
